import * as React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import Normalize from 'react-router-path-normalize'
import { Provider, connect } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import ReduxToastr, { toastr } from 'react-redux-toastr'
import thunk from 'redux-thunk'

import moonlightReducer from './redux/reducers/index'
import { loadState, saveState } from './redux/localStorage'

import Landing from './pages/landing'
import Recordings from './pages/recordings'
import Admin from './pages/admin'
import Location from './pages/location'
import Review from './pages/review'
import Video from './pages/video'
import Note from './pages/note'
import Login from './pages/login'
import PasswordReset from './pages/passwordReset'
import PasswordResetConfirm from './pages/passwordResetConfirm'
import CreateUser from './pages/createUser'
import CostAnalysis from './pages/costAnalysis'
import CostAnalysisInvite from './pages/costAnalysisInvite'
import Verification from './pages/verification'
import VerificationVideo from './pages/verificationVideo'
import TestScripts from './pages/testScripts'

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'

const persistedState = loadState()
let store = createStore(
  moonlightReducer,
  persistedState,
  applyMiddleware(thunk))

const redirectUrl = window.__redirectUrl || 'https://baywatchtechnologies.com/';

store.subscribe(() => {
  saveState(store.getState())
})

class RootComponent extends React.Component {

  PrivateRoute = ({ component: Component, ...rest }) => {
    return <Route {...rest} render={props => {
      if (this.props.auth.isLoading) {
        return <em>Loading...</em>;
      } else if (!this.props.auth.isAuthenticated || this.props.auth.user.is_verifier) {
        return <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
          }} />;
      } else {
        return <Component {...props} />
      }
    }} />
  }

  AdminRoute = ({ component: Component, ...rest }) => {
    return <Route {...rest} render={props => {
      if (this.props.auth.isLoading) {
        return <em>Loading...</em>;
      } else if (!this.props.auth.isAuthenticated) {
        return <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
          }} />;
      } else if(!this.props.auth.user.is_superuser) {
        toastr.error('Error', 'Admin page requires authorization')
        return <Redirect to={{
          pathname: '/visits',
          state: { from: props.location }
          }} />
      } else {
        return <Component {...props} />
      }
    }} />
  }

  VerificationRoute = ({ component: Component, ...rest }) => {
    return <Route {...rest} render={props => {
      if (this.props.auth.isLoading) {
        return <em>Loading...</em>;
      } else if (!this.props.auth.isAuthenticated) {
        return <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
          }} />;
      } else {
        return <Component {...props} />
      }
    }} />
  }

  render() {
    let { PrivateRoute } = this
    let { AdminRoute } = this
    let { VerificationRoute } = this
    return (
      <Router>
        <Normalize>
            <div style={{ display: 'flex' }} className="app-container">
              <Switch>
                <Route exact path='/' component={() => {
                  window.location.href = redirectUrl;
                  return null;
                }} />
                <Route exact path='/login' component={Login} />
                <Route exact path='/password-reset' component={PasswordReset} />
                <Route exact path='/password-reset-confirm' component={PasswordResetConfirm} />
                <Route exact path='/savings/9h8qrp0qef' component={CostAnalysis} />
                <AdminRoute exact path='/admin/locations' component={Admin} />
                <AdminRoute exact path='/admin/locations/:id' component={Location} />
                <AdminRoute exact path='/admin/create-user' component={CreateUser} />
                <AdminRoute exact path='/admin/invite' component={CostAnalysisInvite} />
                <AdminRoute exact path='/admin/test-scripts' component={TestScripts} />
                <PrivateRoute exact path='/visits' component={Recordings} />
                <PrivateRoute exact path='/visits/:id' component={Review} />
                <PrivateRoute exact path='/recordings/:id' component={Video} />
                <PrivateRoute exact path='/recordings/:id/makenote' component={Note} />
                <VerificationRoute exact path='/verification' component={Verification} />
                <VerificationRoute exact path='/verification/:id/recordings/:recordingId' component={VerificationVideo} />
              </Switch>
            </div>
        </Normalize>
      </Router>
    )
  }

}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    user: state.user
  }
}


let RootContainer = connect(mapStateToProps)(RootComponent);

export default class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <div>
          <RootContainer />
          <ReduxToastr
            timeOut={20000}
            newestOnTop={false}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            closeOnToastrClick/>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js